import {
    Checkbox,
    createStyles,
    Fab,
    FormControlLabel,
    FormGroup,
    makeStyles,
    Slide,
    TextField,
    Theme,
} from "@material-ui/core";
import stylesPc from "./FilterWiget.module.css";
import stylesSp from "./FilterWiget_SP.module.css";
import { IsDevice } from "../../../components/function/useDeviceFlag";
import React, { memo, useCallback, useEffect, useState } from "react";
import PresenterIcon from "@material-ui/icons/Person";
//import ProjectIcon from "@material-ui/icons/Work";
import { VideoFilter } from "../../video/models/VideoFilter";
import { useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import PuiTypography from "../../../components/elements/PuiTypography";
import PuiTooltip from "../../../components/elements/PuiTooltip ";
import { FilterTag } from "../../../viewer/search/Search";
import FilterListIcon from "../images/FilterListIcon";
// import Tag from "../../../assets/image/tag.svg";
interface CheckObject {
    [key: string]: boolean;
}

interface FilterWigetProps {
    contents: any[];
    videoFilter: VideoFilter;
    checkedItems: CheckObject;
    changeProfessionalFilter?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    changeProjectFilter?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    changeTagFilter?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    setCheckedItems: (checkedItems: CheckObject) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        wrapper: {
            position: "relative",
            marginTop: theme.spacing(3),
        },
        actionButton: {
            position: IsDevice("desktop") ? "absolute" : "fixed",
            top: IsDevice("iphone") ? "none" : IsDevice("ipad") ? "none" : "-96px",
            right: IsDevice("iphone") ? "12px" : IsDevice("ipad") ? "23px" : "-4px",
            bottom: IsDevice("iphone") ? "12px" : IsDevice("ipad") ? "21px" : "0",
            width: "40px",
            height: "40px",
            boxShadow: "none",
            backgroundColor: "#24282E",
            zIndex: 98,
            "&:hover": {
                backgroundColor: "#292E36",
            },
        },
        listIcon: { paddingTop: "8px" },
        divider: {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(-1),
        },
        icon: {
            color: "var(--white)",
            marginRight: "10px",
        },
        tagCheckBox: {
            marginLeft: theme.spacing(1),
            marginBottom: "-12px",
        },
        formGroupRoot: {
            display: "flex",
            flexDirection: "column",
            flexWrap: "nowrap",
        },
        conditionSelect: {
            width: "100%",
            backgroundColor: "#E8E8E8",
            borderRadius: "5px 5px 0px 0px",
            "& .MuiInputLabel-root.Mui-focused": {
                color: "rgba(0, 0, 0, 0.54)",
            },
            "& .MuiFilledInput-underline:after": {
                borderBottom: "2px solid rgba(0, 0, 0, 0.54)",
            },
        },
    })
);

function FilterWiget({
    contents,
    videoFilter,
    checkedItems,
    changeProfessionalFilter,
    changeProjectFilter,
    changeTagFilter,
    setCheckedItems,
}: FilterWigetProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const classes = useStyles();
    const [openFilterModal, setOpenFilterModal] = React.useState(false);
    const [selectProfessional, setSelectProfessional] = React.useState<string[]>([""]);
    //const [selectProject, setSelectProject] = React.useState<string[]>([""]);
    const [currentTags, setcurrentTags] = useState<FilterTag[]>([]);

    const { projectList } = useSelector(({ exProject }: AppState) => exProject);
    // const { tags } = useSelector((state: AppState) => ({
    //     tags: state.video.filterTags,
    // }));

    const handleOuterClick = useCallback(() => {
        setOpenFilterModal(false);
        document.removeEventListener("click", handleOuterClick);
    }, []);

    const handleOpen = useCallback(
        (toSet: boolean) => () => {
            setOpenFilterModal(toSet);

            if (toSet) {
                document.addEventListener("click", handleOuterClick);
            } else {
                document.removeEventListener("click", handleOuterClick);
            }
        },
        [setOpenFilterModal, handleOuterClick]
    );

    const handlePropagation = useCallback((event: React.MouseEvent) => {
        event.nativeEvent.stopImmediatePropagation();
    }, []);

    const changeProfessionalHandle = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            if (changeProfessionalFilter) {
                changeProfessionalFilter(event);
            }
        },
        [changeProfessionalFilter]
    );

    /*     const changeProjectHandle = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        if (changeProjectFilter) {
            changeProjectFilter(event);
        }
    }, [changeProjectFilter]); */

    const changeTagHandle = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            if (changeTagFilter) {
                changeTagFilter(event);
            }
        },
        [changeTagFilter]
    );

    useEffect(() => {
        if (Array.isArray(contents)) {
            const pList = [""];
            const tagList: string[] = [];
            const filterTags: FilterTag[] = [];
            contents.forEach((element) => {
                // プレゼンター
                if (!pList.includes(element.presenter)) {
                    pList.push(element.presenter);
                }

                // tag表示をvideoとslidestockを分ける
                for (let i = 0; i < element.tags.length; i++) {
                    if (!tagList.includes(element.tags[i])) {
                        tagList.push(element.tags[i]);
                        const damiTag = {
                            tag: element.tags[i],
                            tagCount: 1,
                        };
                        filterTags.push(damiTag);
                    } else {
                        const index = filterTags.findIndex((item) => item.tag === element.tags[i]);
                        filterTags[index].tagCount += 1;
                    }
                }
            });
            setSelectProfessional(pList);
            setcurrentTags(filterTags);
        }

        if (Array.isArray(projectList)) {
            const pjList = [""];
            projectList.forEach((element) => {
                if (!pjList.includes(element.title)) {
                    pjList.push(element.title);
                }
            });
        }
        // setSelectProject(pjList);
    }, [contents, projectList]);

    return (
        <div className={classes.wrapper} onClick={handlePropagation}>
            <Fab
                variant="circular"
                size="small"
                className={classes.actionButton}
                onClick={handleOpen(!openFilterModal)}
            >
                {openFilterModal ? (
                    <img src={require("../../../assets/image/closeFilter.svg")} alt="tag" />
                ) : (
                    <div className={classes.listIcon}>
                        <FilterListIcon />
                    </div>
                )}
            </Fab>
            <Slide direction="left" in={openFilterModal} mountOnEnter unmountOnExit>
                <div className={styles.widget}>
                    <div className={styles.condArea}>
                        <div className={styles.widgetSubTitle}>
                            <PresenterIcon className={classes.icon} />
                            <PuiTypography size={17} bold={true} color={"white"}>
                                プレゼンターで絞り込む
                            </PuiTypography>
                        </div>
                        <div
                            style={{
                                marginLeft: "27px",
                                marginTop: "20px",
                                width: "270px",
                                borderRadius: "5px 5px 0px 0px",
                            }}
                        >
                            <TextField
                                id="professionalFilter"
                                label="プレゼンター"
                                select
                                SelectProps={{ native: true }}
                                variant="filled"
                                size="small"
                                onChange={changeProfessionalHandle}
                                value={videoFilter.professional[0]}
                                className={classes.conditionSelect}
                            >
                                {selectProfessional.map((value, index) => (
                                    <option key={index} value={value}>
                                        {value}
                                    </option>
                                ))}
                            </TextField>
                        </div>
                        {/* <div className={styles.widgetSubTitle} >
                            <ProjectIcon className={classes.icon}/>
                            <PuiTypography size={20} bold={true} color={"primary-font"}>Projectで絞り込む</PuiTypography>
                        </div>
                        <TextField
                            id="projectFilter"
                            label="Project"
                            select
                            SelectProps={{native: true}}
                            variant="filled"
                            size="small"
                            onChange={changeProjectHandle}
                            value={videoFilter.project[0] === undefined ? "" : videoFilter.project[0]}
                            className={classes.conditionSelect}
                        >
                            {selectProject.map((value, index) => (
                                <option key={index} value={value}>
                                    {value}
                                </option>
                            ))}   
                        </TextField> */}

                        {/* <Divider variant="fullWidth" className={classes.divider}/> */}
                        <div className={styles.tag}>
                            <img
                                src={require("../../../assets/image/tag.svg")}
                                style={{ height: "16px", marginLeft: "5px", marginRight: "11px" }}
                                alt="tag"
                            />
                            <PuiTypography size={17} bold={true} color={"white"}>
                                タグで絞り込む
                            </PuiTypography>
                        </div>
                    </div>
                    <FormGroup className={styles.tagArea} classes={{ root: classes.formGroupRoot }}>
                        {currentTags &&
                            currentTags.length > 0 &&
                            currentTags.map((item, index) => (
                                <div key={index} className={styles.widgetCheckbox}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                style={{ color: "white" }}
                                                checkedIcon={
                                                    <img
                                                        src={require("../../../assets/image/checked_box.svg")}
                                                        alt={`checkedIcon_${index}`}
                                                        className={styles.checkedIcon}
                                                    />
                                                }
                                                checked={checkedItems[item.tag] || false}
                                                onChange={changeTagHandle}
                                                name={item.tag}
                                            />
                                        }
                                        label={
                                            <div className={styles.widgetCheckboxText}>
                                                <div
                                                    className={styles.widgetCheckboxTag}
                                                    data-tip={item.tag}
                                                    data-for="tagName"
                                                >
                                                    <PuiTypography color={"white"}>
                                                        {item.tag}
                                                    </PuiTypography>
                                                </div>
                                                <PuiTooltip id="tagName" />
                                                <div style={{ opacity: "0.5" }}>
                                                    <PuiTypography color="white">{`(${item.tagCount})`}</PuiTypography>
                                                </div>
                                            </div>
                                        }
                                        className={classes.tagCheckBox}
                                    />
                                </div>
                            ))}
                    </FormGroup>
                </div>
            </Slide>
        </div>
    );
}

export default memo(FilterWiget);
